import { Container, Divider, Grid } from "@mui/material";
import Skeleton from "../../common/skeleton/skeleton";

function HotelSkeleton() {
    return (
        <Container maxWidth="xl">
            <Grid container item xs={12} rowGap={2} justifyContent="space-between" alignItems="flex-start">
                <Grid className="base-sort" container item xs={2} rowGap={1} display={{ xs: "none", md: "flex" }}>
                    <Skeleton variant="rounded" animation="wave" width="100%" height={30} />
                    <Skeleton variant="rounded" animation="wave" width="100%" height={200} />
                </Grid>

                <Grid container item xs={12} columnGap={2} display={{ xs: "flex", md: "none" }} alignItems="center" mt={2}>
                    <Skeleton variant="text" animation="wave" width={50} height={20} />
                    <Divider flexItem orientation="vertical" />
                    <Skeleton variant="text" animation="wave" width={50} height={20} />
                </Grid>

                <Grid container item md={9.8} rowGap={2}>
                    <Grid className="base-sort" container item xs={12} md="auto" columnGap={2} display={{ xs: "none", md: "flex" }}>
                        {[...Array(2)].map((_, index) => (
                            <Grid key={index} container item xs="auto">
                                <Skeleton variant="text" animation="wave" width={100} height={20} />
                            </Grid>
                        ))}
                    </Grid>

                    {[...Array(10)].map((_, index) => (
                        <Grid className="hotel-item" key={index} container item xs={12} rowGap={1} justifyContent="space-between" alignItems="center">
                            <Grid container item xs={12} md={2.5} xl={2} my={1}>
                                <Skeleton variant="rounded" animation="wave" height={120} sx={{ width: { xs: "100%", md: 200 } }} />
                            </Grid>

                            <Grid container item xs={12} md={4.75} xl={5.5} direction="column" rowGap={2} justifyContent="space-between">
                                <Skeleton variant="text" animation="wave" width={200} height={20} />
                                <Skeleton variant="text" animation="wave" width="100%" height={20} />
                            </Grid>

                            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "flex" } }} />

                            <Grid container item xs={12} md={4.25} xl={3.5} rowGap={2} justifyContent="center" alignItems="center">
                                <Skeleton variant="text" animation="wave" width={250} height={20} />
                                <Grid container item xs={12} display={{ xs: "none", md: "flex" }} justifyContent="space-evenly" alignItems="flex-end">
                                    <Skeleton variant="rounded" animation="wave" width={100} height={30} />
                                    <Skeleton variant="rounded" animation="wave" width={100} height={30} />
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Container>
    );
}

export default HotelSkeleton;
